module.exports = __webpack_public_path__ + "static/dgsp-78df8a7599ee357c0a132ed1139d9f6f.jpg";